<template>
    <div
        v-if="str"
        class="app-container"
        :class="{'app-container-flex': success}"
    >
        <div v-if="!linkExpired" class="app-content">
            <div
                v-if="!success"
                class="app-image"
            >
                <img
                    v-if="logo"
                    :src="logo"
                />
                <img
                    v-if="!logo"
                    :src="'https://ptclient.mkgest.com/app/' + Math.abs(ptId) + '/logo.jpg'"
                />
            </div>
            <div
                v-if="!success"
                class="app-title text-bold"
            >
                {{ str['set_new_password'] }}
            </div>
            <div
                v-if="success"
                class="app-title text-bold"
            >
                <div class="app-title-icon">
                    <i
                        color="black"
                        class="fa fa-check app-title-icon-element"
                    />
                </div>
                <div>
                    {{ str['successful_password_recovery'] }}
                </div>
            </div>
            <div
                v-if="!success"
                class="app-body"
            >
                <div class="form-row">
                    <span class="form-row-title">
                        {{ str['password'] }}
                    </span>
                    <v-text-field
                        v-model="password"
                        :type="visiblePasswords.indexOf('password') > -1 ? 'text' : 'password'"
                        class="form-row-input-password"
                        hide-details
                        rounded
                    />
                    <span
                        v-show="visiblePasswords.indexOf('password') > -1"
                        class="form-row-password-icon"
                        @click="showPassword('password')"
                    >
                        <i class="fa fa-eye" />
                    </span>
                    <span
                        v-show="visiblePasswords.indexOf('password') < 0"
                        class="form-row-password-icon"
                        @click="showPassword('password')"
                    >
                        <i class="fa fa-eye-slash" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-row-title">
                        {{ str['confirm_password'] }}
                    </span>
                    <v-text-field
                        v-model="confirmPassword"
                        :type="visiblePasswords.indexOf('confirmPassword') > -1 ? 'text' : 'password'"
                        class="form-row-input-password"
                        hide-details
                        rounded
                    />
                    <span
                        v-show="visiblePasswords.indexOf('confirmPassword') > -1"
                        class="form-row-password-icon"
                        @click="showPassword('confirmPassword')"
                    >
                        <i class="fa fa-eye" />
                    </span>
                    <span
                        v-show="visiblePasswords.indexOf('confirmPassword') < 0"
                        class="form-row-password-icon"
                        @click="showPassword('confirmPassword')"
                    >
                        <i class="fa fa-eye-slash" />
                    </span>
                </div>
            </div>
            <div
                v-if="!success"
                class="app-footer"
            >
                <div>
                    <v-btn
                        @click="confirm()"
                        color="success"
                    >
                        {{ str['confirm'] }}
                    </v-btn>
                </div>
            </div>
        </div>
        <div v-if="linkExpired" class="app-content">
            <div class="app-title text-bold">
                Link expirado. Por favor, solicite um novo link.
            </div>
        </div>
    </div>
</template>

<script>
    import Api from '../services/Api'
    import Utils from '../services/Utils'

    export default {
        data() {
            return {
                str: null,
                ptId: window.ptId,
                success: false,
                password: '',
                confirmPassword: '',
                visiblePasswords: [],
                logo: window.webviewConfig && window.webviewConfig.logo ? window.webviewConfig.logo : null,
                linkExpired: false
            }
        },
        beforeMount: function () {
            this.validateExpireDate()
            this.getStrings()
        },
        methods: {
            validateExpireDate: function () {
                const queryString = window.location.search
                const urlParams = new URLSearchParams(queryString)
                const expiresAt = urlParams.get('expires_at')
                if (expiresAt) {
                    const expirationTime = parseInt(expiresAt)
                    const currentTime = new Date().getTime()
                    if (currentTime > expirationTime) {
                        this.linkExpired = true
                        return false
                    }
                }
                return true
            },
            getStrings: function () {
                Api.getStrings( (response) => {
                    if (response.success) {
                        window.strings = response.data
                        this.str = response.data
                        Utils.refreshAppUrl()
                    } else {
                        this.str = {
                            set_new_password: 'Definir nova palavra-passe',
                            successful_password_recovery: 'Palavra-passe atualizada com sucesso',
                            password: 'Palavra-passe',
                            confirm_password: 'Confirmar Palavra-passe',
                            confirm: 'Confirmar',
                            password_distinct_error: 'As palavras-passe não correspondem. Por favor, verifique e tente novamente.',
                            ok: 'Ok',
                            cancel: 'Cancelar'
                        }
                    }
                })
            },
            showPassword: function (id) {
                const index = this.visiblePasswords.indexOf(id)
                if (index > -1) {
                    this.visiblePasswords.splice(index, 1)
                } else {
                    this.visiblePasswords.push(id)
                }
            },
            confirm: function () {
                if (this.password !== this.confirmPassword) {
                    return this.$alert(
                        this.str['password_distinct_error'],
                        '',
                        'warning',
                        Utils.getAlertOptions()
                    )
                }
                this.$isLoading(true)
                Api.updateUser({
                    password: this.password
                }, (response) => {
                    this.$isLoading(false)
                    if (response.success) {
                        this.success = true
                    } else {
                        this.$alert(
                            response.message,
                            '',
                            'warning',
                            Utils.getAlertOptions()
                        )
                    }
                })
            },
        },
    }
</script>